import { HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/of';
import { environment } from '../../environments/environment';
var ConfigurationService = /** @class */ (function () {
    function ConfigurationService(http) {
        this.http = http;
        this.serverUrl = environment.serverUrl;
    }
    ConfigurationService.prototype.getConfigurations = function () {
        var reqEndPoint = 'configurations';
        return this.http.get(this.serverUrl + reqEndPoint);
    };
    ConfigurationService.prototype.tokenTest = function () {
        var reqEndPoint = 'users/tokentest';
        return this.http.get(this.serverUrl + reqEndPoint);
    };
    ConfigurationService.prototype.getUTCTime = function () {
        return this.http.get(this.serverUrl + 'utctime');
    };
    return ConfigurationService;
}());
export { ConfigurationService };



// WEBPACK FOOTER //
// ./src/app/services/config.service.ts.pre-build-optimizer.js